'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _predicate = require('../utils/predicate');

var _keyToObjectValueResolver = require('../resolvers/keyToObjectValueResolver');

var _keyToObjectValueResolver2 = _interopRequireDefault(_keyToObjectValueResolver);

var _parse = require('../utils/parse');

var _objects = require('../utils/objects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataLookupTransformer = function dataLookupTransformer(dataNodeName) {
  return function (value, data, breakpointName) {
    var aliases = (0, _objects.filterKeys)((0, _ramda.equals)(dataNodeName), data.aliases);
    return (0, _ramda.when)((0, _predicate.isTokenWithName)((0, _ramda.prepend)(dataNodeName, aliases)), function () {
      var name = (0, _parse.nameOfNamedValue)(value);
      return (0, _keyToObjectValueResolver2.default)(dataNodeName)(name, data, breakpointName);
    })(value);
  };
};

exports.default = dataLookupTransformer;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/transformers/dataLookupTransformer.js
// module id = 667
// module chunks = 168707334958949